<script>
  import { domainName, record } from '../stores.js';
</script>

<div class="record-box record-raw">
  <div id="headingRaw" class="box-label">
    <h5>How Your Logo Will Appear: <span>{$domainName}</span></h5>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseLogoLook" aria-expanded="true" aria-controls="collapseLogoLook" aria-label="Close"></button>
  </div>
  <div id="collapseLogoLook" class="collapse show" aria-labelledby="headingRaw">
    <div class="image-box">
      <div class="bimi-look">
        <div class="image-wrap mobile d-flex justify-content-center justify-content-lg-between align-items-end">
          <img referrerpolicy="no-referrer" src="{$record.logo}" alt="{$domainName} logo" class="logo">
          <img referrerpolicy="no-referrer" src="{$record.logo}" alt="{$domainName} logo" class="logo">
          <img class="img-fluid" src="/modules/custom/fortra_tools/images/bimi_mobile.png" alt="Mobile view">
        </div>
        <div class="image-wrap site justify-content-center justify-content-lg-between align-self-center">
          <img referrerpolicy="no-referrer" src="{$record.logo}" alt="{$domainName} logo" class="logo">
          <img class="img-fluid" src="/modules/custom/fortra_tools/images/bimi_site.png" alt="Desktop view">
        </div>
    </div>
    </div>
  </div>
</div>

<style>
  .image-box {
    padding: 1rem 0;
  }

  .image-wrap {
    position: relative;
  }

  .bimi-look {
    display: block;
    text-align: center;
  }

  .bimi-look img {
    height: 100%;
  }

  .bimi-look .mobile {
    height: 260px;
    margin-bottom: 1rem;
  }

  .bimi-look .mobile .logo {
    border-radius: 50%;
    height: auto;
    width: 5%;
    object-fit: contain;
    position: absolute;
    top: 22%;
    left: 27%;
    transform: translateY(-50%);
  }

  .bimi-look .mobile .logo:nth-child(2) {
    top: 56.5%;
  }

  .bimi-look .site {
    height: 250px;
  }

  .bimi-look .site .logo {
    position: absolute;
    top: 26.5%;
    left: 14%;
    max-height: 10px;
    object-fit: contain;
    height: auto;
    width: 7%;
  }

  @media (min-width: 768px) {
    .bimi-look {
      position: relative;
      display: flex;
      justify-content: space-around;
    }

    .bimi-look .mobile {
      height: 326px;
      width: 204px;
    }

    .bimi-look .mobile .logo {
      width: 8%;
      left: 11%;
    }
  }

</style>
